<script setup lang="ts">
import { ref, onMounted, toRefs, computed, watch } from 'vue';
const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  title: { type: String, default: '' },
  icon: { type: String, default: '' },
  // 兼容传入对象样式与字符串样式（部分页面直接传 style 字符串）
  style: { type: [Object, String], default: () => ({}) },
  margin: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  highLight: { type: Boolean, default: false },
});

const { title, icon, style, margin, disabled } = toRefs(props);
</script>

<template>
  <div
    class="setting-box"
    :class="{ 'mb-12': margin, 'high-light': highLight }"
    :style="style"
  >
    <div class="fr-ac-jsb">
      <div class="fr-ac h-32" style="flex-shrink: 0" v-if="title || icon">
        <IconFont
          v-if="icon"
          class="mr-9"
          :class="{ opa4: disabled }"
          :name="icon"
          :size="18"
        />
        <div v-if="title" :class="{ opa4: disabled }" class="fs-18 fw-500">
          {{ title }}
        </div>
      </div>
      <slot name="head-right"> </slot>
    </div>
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.setting-box {
  background: var(--card-bg-color);
  /*background: linear-gradient(
    180deg,
    rgb(54, 98, 199, 0.2) 0%,
    rgb(21, 35, 74, 0.2) 100%
  );*/
  border-radius: var(--border-radius);
  padding: 25px 30px 25px 30px;
}

.high-light {
  /*background: linear-gradient(
    180deg,
    //rgba(40, 207, 181, 1) 0%,
    rgb(5, 41, 66) 0%,
    rgba(152, 104, 254, 0.1) 100%
  );*/
  background: var(--card-bg-color-active);
}
</style>
